module.exports = require(process.env.NODE_ENV === 'production' ? './config.production.js' : './config.development.js')



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 285
// module chunks = 0